module.exports = __webpack_public_path__ + "img/pay.7ab3327a.png";